export default "__VITE_ASSET__BiJLa3PY__"